import React from "react";
import Slider from "react-slick";
import s1 from "../../assets/carousel/1.png";
import s2 from '../../assets/carousel/2.png';
import s3 from '../../assets/carousel/3.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";

function carousel() {
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true
  };
  return (
    <div className="slider-container">
      <Slider {...settings}style={{ width: "100%",height: "5vh", overflow: "visible" }}>
        <div>
          <h3><img src={s1} alt="" /></h3>
        </div>
        <div>
        <h3><img src={s2} alt="" /></h3>
        </div>
        <div>
        <h3><img src={s3} alt="" /></h3>
        </div>
        
      </Slider>
    </div>
  );
}

export default carousel;
